import { Chip } from "@features/atoms/Chip"
import dayjs from "dayjs"
import { Link } from "eddev/routing"

export const BlogPostTile = ({
  title,
  categories,
  date,
  readTime,
  link,
}: {
  title: string
  categories: string[]
  date: string
  readTime: string
  link: string
}) => {
  return (
    <Link
      href={link}
      className="w-full aspect-square p-7 rounded-md flex flex-col justify-between border-white/20 border transition-all hover:border-white/0 duration-700 relative overflow-hidden group"
    >
      <div className="absolute w-[200%] h-[200%] top-0 left-0 -mt-[50%] bg-black group-hover:opacity-100 opacity-0 transition-opacity duration-500">
        <div className="purple-gradient absolute left-0 top-0 w-full h-full opacity-0 transition-opacity duration-1000 group-hover:opacity-70" />
      </div>
      <div className="flex gap-4 relative">
        {categories.map((category) => (
          <Chip key={category}>{category}</Chip>
        ))}
      </div>
      <div className="flex flex-col gap-7 relative">
        <h3 className="type-title-s">{title}</h3>
        <p className="flex flex-row gap-3 type-label-l text-white/60">
          <span>{dayjs(date).format("D MMMM")}</span>
          <span>—</span>
          <span>{readTime}</span>
        </p>
      </div>
    </Link>
  )
}
